import React, { useState } from 'react';

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
} from 'recharts';
import { Header, Checkbox } from 'semantic-ui-react';

const axisLabelStyles = {
  fontSize: 12,
  textAnchor: 'middle',
  fontFamily: 'Poppins',
  fontWeight: 600,
  fill: '#919191',
  textTransform: 'uppercase',
};

const MediaVsBaselineChart = ({ mediaVsBaseline, isConversionKPI }) => {
  const [percentage, setPercentage] = useState(false);
  const format = v => v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 3 });

  if (!mediaVsBaseline || !mediaVsBaseline.length) return null;

  return (
    <>
      <Header as="h2">
        <div style={{ display: 'flex' }}>
          <div>Media vs Baseline Contribution</div>
          <Checkbox
            id="percentage-checkbox"
            style={{ marginLeft: '2rem' }}
            toggle
            label="100% Stacked"
            checked={percentage}
            onChange={() => setPercentage(!percentage)}
          />
        </div>
      </Header>
      <ResponsiveContainer width="95%" height={400}>
        <AreaChart width={500} height={700} data={mediaVsBaseline}>
          <Legend
            layout="horizontal"
            verticalAlign="top"
            align="center"
          />
          <Tooltip formatter={(value, name) => {
            if (name === 'Baseline') {
              return [`${format(value)}${percentage ? '%' : ''}`, 'Baseline'];
            }
            return [`${format(value)}${percentage ? '%' : ''}`, 'Media'];
          }}
          />
          <XAxis dataKey="date" angle={-45} textAnchor="end" height={60} interval="preserveStart" />
          <YAxis
            domain={percentage ? [0, 100] : [0, 'auto']}
            tickFormatter={v => (percentage ? `${Math.round(v)}%` : isConversionKPI ? v : `${v}`)}
            width={100}
          >
            <Label value={isConversionKPI ? 'Conversions' : 'Revenue'} angle={-90} position="insideLeft" style={axisLabelStyles} />
          </YAxis>
          <Area
            name="Baseline"
            type="monotone"
            dataKey={percentage ? 'baselinePct' : 'baselineContribution'}
            stackId="1"
            stroke="#1F77B4"
            fill="#1F77B4"
          />
          <Area
            name="Media"
            type="monotone"
            dataKey={percentage ? 'mediaPct' : 'mediaContribution'}
            stackId="1"
            stroke="#FF7F0F"
            fill="#FF7F0F"
          />
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
};

export default MediaVsBaselineChart;
